import React from 'react'
import { graphql, Link, useStaticQuery } from 'gatsby'
import SocialLinks from 'embeds/social-links'
import { EmailLink, PhoneLink } from 'components/design'

export default function Footer() {
	const {
		emails,
		main_email,
		main_subheading,
		phone_formatted,
		country_specific_phones,
		social_links,
	} = useContactPageData()

	return (
		<footer className={`bg-black text-white`}>
			<div className="mx-screen-step flex justify-between border-b border-white/25 pt-10 pb-6 lg:py-16">
				<div className="hidden w-screen-step-5 lg:block">
					<Link
						className="accent-hover block opacity-50 !transition !duration-300 hover:opacity-100"
						to="/"
					>
						<h4 className="text-xl font-semibold leading-none">Studio</h4>
					</Link>
					<Link
						className="accent-hover mt-10 block leading-none"
						to="/projects/"
					>
						Projects
					</Link>
					<Link className="accent-hover mt-8 block leading-none" to="/about/">
						About us
					</Link>
					<Link className="accent-hover mt-8 block leading-none" to="/blog/">
						Blog
					</Link>
					<Link className="accent-hover mt-8 block leading-none" to="/art/">
						Art
					</Link>
					<Link className="accent-hover mt-8 block leading-none" to="/careers/">
						Careers
					</Link>
				</div>

				<div className="hidden w-screen-step-6 lg:block">
					<h4 className="text-xl font-semibold leading-none opacity-50">
						Services
					</h4>
					<Link
						className="accent-hover mt-10 block leading-none"
						to="/services/exterior-rendering/"
					>
						Exterior rendering
					</Link>
					<Link
						className="accent-hover mt-8 block leading-none"
						to="/services/interior-rendering/"
					>
						Interior rendering
					</Link>
					<Link
						className="accent-hover mt-8 block leading-none"
						to="/services/architectural-animation/"
					>
						Architectural animation
					</Link>
					<Link
						className="accent-hover mt-8 block leading-none"
						to="/services/architectural-virtual-reality/"
					>
						Architectural virtual reality
					</Link>
				</div>

				<div className="hidden w-screen-step-6 lg:block">
					<h4 className="text-xl font-semibold leading-none opacity-50">
						Support
					</h4>
					<Link className="accent-hover mt-10 block leading-none" to="/faq/">
						Frequently asked questions
					</Link>
					<Link
						className="accent-hover mt-8 block leading-none"
						to="/contacts/"
					>
						Contact us
					</Link>
					<button
						id="schedule-a-call-footer"
						className="accent-hover mt-8 cursor-pointer leading-none"
						onClick={() => {
							/* global Calendly */
							Calendly.showPopupWidget(
								'https://calendly.com/cuubstudio/30min'
							)
						}}
					>
						Schedule a call
					</button>
				</div>

				<div className="w-screen-step-8 lg:w-screen-step-5">
					<h4 className="text-base font-semibold leading-none opacity-50 lg:text-xl">
						Follow us
					</h4>
					<div className="mt-8 flex w-full">
						<SocialLinks links={social_links} largeOnMobile />
					</div>
				</div>
			</div>

			<div className="mx-screen-step flex flex-col gap-y-8 border-b border-white/25 py-8 lg:flex-row lg:justify-between lg:gap-y-0 lg:py-16">
				<div className="w-full lg:w-screen-step-5">
					<h4 className="text-xs font-semibold leading-none opacity-50 lg:text-base">
						{main_subheading}
					</h4>
					<div className="mt-2 text-base font-semibold lg:mt-8 lg:text-xl">
						<EmailLink email={main_email} />
					</div>
					<div className="mt-2 text-base font-semibold lg:mt-8 lg:text-xl">
						<PhoneLink
							number={phone_formatted}
							countrySpecific={country_specific_phones}
						/>
					</div>
				</div>

				{emails.slice(0, 2).map(({ address, label }) => (
					<div className="w-full lg:w-screen-step-6" key={address}>
						<h4 className="text-xs font-semibold leading-none opacity-50 lg:text-base">
							{label}
						</h4>
						<div className="mt-2 text-base font-semibold lg:mt-8 lg:text-xl">
							<EmailLink email={address} />
						</div>
					</div>
				))}

				<div className="w-full lg:w-screen-step-5">
					<h4 className="text-xs font-semibold leading-none opacity-50 lg:text-base">
						Start a project
					</h4>
					<Link
						to="https://research.typeform.com/to/d5SVcDHm"
						className="mt-2 block text-base font-semibold text-accent transition-colors duration-300 hover:text-white lg:mt-8 lg:text-xl"
					>
						Fill out our brief
					</Link>
				</div>
			</div>

			<div className="mx-screen-step flex justify-between py-7 text-xs opacity-50 lg:text-base">
				<p>&copy; {new Date().getFullYear()} CUUB Studio. All rights reserved.</p>
			</div>
		</footer>
	)
}

function useContactPageData() {
	const response = useStaticQuery(graphql`
		query FooterQuery {
			prismicContactsPage {
				...ContactsFragment
			}
		}
	`)

	return response.prismicContactsPage.data
}
